import React from "react";
import { Dialog, DialogContent } from "@mui/material";
import { Button, Iconography, IconographySizes } from "@hid-galaxy-ui/galaxy-react";

type Props = {
  open: boolean;
  featureName: string;
  onClose: () => void;
  onConfirm: () => void;
};

const DeleteFeatureModal: React.FC<Props> = ({
  open,
  featureName,
  onClose,
  onConfirm,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <div className="benefits-ptv-modal benefits-delete-modal">
        <header className="benefits-ptv-modal-header">
          <div className="benefits-delete-heading">
            <span className="benefits-delete-icon">
              <Iconography icon="circleExclamation" size={IconographySizes.Small} />
            </span>
            <h3>Delete Feature?</h3>
          </div>
        </header>
        <DialogContent className="benefits-ptv-modal-content">
          <p>
            Are you sure to delete <strong>&quot;{featureName}&quot;</strong>. This action cannot
            be undone and will remove this feature from settings.
          </p>
          <div className="benefits-warning-box" role="alert">
            <Iconography icon="circleExclamation" size={IconographySizes.Medium} />
            <div>
              <h4>Warning notification</h4>
              <p>
                Features delete can't be undone from the settings.
              </p>
            </div>
          </div>
        </DialogContent>
        <footer className="benefits-ptv-modal-footer">
          <Button variant="secondary" label="CANCEL" onClick={onClose} />
          <Button variant="primary" label="DELETE" onClick={onConfirm} />
        </footer>
      </div>
    </Dialog>
  );
};

export default DeleteFeatureModal;
